/* eslint-disable no-undef */
export default {
	name: "tracking-history-modal",
	props: ["heading", "modalId", "showModal", "orderId"],
	emits: ["okButtonClicked"],
	data() {
		return {
			trackingHistory: [],
			modalHeading: null,
			modalComponentId: null,
			formIsSaving: false,
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			loading: false
		};
	},
	methods: {
		getOrderTrackingHistory(){
			this.loading = true;
			orderService.getTrackingHistoriesForOrder(this.orderId).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.trackingHistory = successResponse.data.result;
						for(let i = 0; i < this.trackingHistory.length; i++){
							this.trackingHistory[i].trackingDate = moment(this.trackingHistory[i].insertedOn).format("DD/MM/YYYY HH:mm");
						}
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onOkClick(){
			this.$emit("okButtonClicked", true)
		}
	},
	mounted: function () {
        
	},
	watch: {
		orderId:{
			handler: function () {
				if(this.orderId !== null && this.orderId > 0){
					this.getOrderTrackingHistory();
				}
			},
			immediate: true,
			deep: true
		},
		heading: {
			handler: function () {
				if(this.heading){
					this.modalHeading = this.heading;
				}
			},
			immediate: true,
			deep: true
		},
		modalId:{
			handler: function () {
				if(this.modalId){
					this.modalComponentId = this.modalId;
				}
			},
			immediate: true,
			deep: true
		},
		showModal:{
			handler: function () {
				if (this.showModal) {
					$("#" + this.modalId).modal("show");
				}
				else{
					$("#" + this.modalId).modal("hide");
				}
			},
			immediate: true,
			deep: true
		}
	}
};
